import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetStatsEnvironment } from '../fleet-stats-environment';

/**
 * Gets asset stats
 * @returns Asset Stats
 */
export function getDashboardAccountStatsAssets(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetStatsEnvironment.resolve(this).dashboardAccountStatsAssetsUrl,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        assetsWithNoLicense: z.number(),
        assetsWithUnActivatedLicense: z.number(),
      })
    )
  );
}
